// extracted by mini-css-extract-plugin
module.exports = {"customMedia":{},"customProperties":{},"customSelectors":{}};